export class ChangePasswordINModel {
    desEmail: string
    newPassword: string
    oldPassword: string 
}